import { Sparkles, Plus } from 'lucide-react';

export default function StepBrief({ brief, onChange, chips }) {
  const appendChip = (chip) => {
    const base = brief.trim();
    const next = base ? `${base}\n• ${chip}` : `• ${chip}`;
    onChange(next);
    // Don't refocus the textarea — that forces the mobile keyboard to open
  };

  return (
    <div data-testid="step-brief" className="animate-[fadeIn_0.4s_ease]">
      <div className="mb-6">
        <p className="text-[10px] uppercase tracking-widest text-[#00E5FF] mb-2 font-bold">Step 3 · Project Intelligence</p>
        <h2 className="font-['Outfit'] text-2xl sm:text-4xl font-bold text-[#0A0A0A] dark:text-white leading-tight">Tell me your vision</h2>
        <p className="text-sm text-slate-400 dark:text-slate-400 mt-2 max-w-md">A few sentences is plenty — what you want, who it's for, and any must-haves. This is auto-saved as you type.</p>
      </div>

      <div className="relative rounded-2xl border border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-white/[0.02] backdrop-blur-xl overflow-hidden focus-within:border-[#00E5FF]/50 focus-within:shadow-[0_0_32px_rgba(0,229,255,0.1)] transition-all">
        <div className="flex items-center gap-2 px-4 py-2.5 border-b border-slate-100 dark:border-white/5 bg-slate-50 dark:bg-white/[0.02]">
          <Sparkles className="w-3.5 h-3.5 text-[#00E5FF]" />
          <span className="text-[10px] uppercase tracking-widest text-slate-500 dark:text-slate-500 font-bold">Your brief</span>
          <span className="ml-auto text-[10px] text-slate-400 dark:text-slate-600 font-mono">{brief.length} chars</span>
        </div>
        <textarea
          data-testid="brief-textarea"
          value={brief}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Briefly describe your vision or any must-have features…"
          rows={7}
          className="w-full bg-transparent text-[#0A0A0A] dark:text-white text-base leading-relaxed px-5 py-4 resize-none outline-none placeholder:text-slate-400 dark:text-slate-600 caret-[#00E5FF]"
        />
      </div>

      {chips?.length > 0 && (
        <div className="mt-5">
          <p className="text-[10px] uppercase tracking-widest text-slate-500 dark:text-slate-500 font-bold mb-2.5">Need a prompt? Tap to add</p>
          <div className="flex flex-wrap gap-2">
            {chips.map(chip => (
              <button
                key={chip}
                type="button"
                data-testid={`brief-chip-${chip.slice(0, 12).replace(/\s/g, '-')}`}
                onClick={() => appendChip(chip)}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] text-slate-400 dark:text-slate-300 bg-slate-50 dark:bg-white/[0.03] border border-slate-200 dark:border-white/10 hover:border-[#00E5FF]/40 hover:text-[#0A0A0A] dark:hover:text-white hover:bg-[#00E5FF]/5 transition-all active:scale-95"
              >
                <Plus className="w-3 h-3" />
                {chip}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
